import { useRouter } from 'next/router';
import { TextInput } from '@domain-group/fe-co-form-elements';
import React, { FC, useState } from 'react';
import * as gtag from '../../lib/gtag';
import * as styles from './search-box.styles';

interface SearchBoxProps {
  version: string;
}

const SearchBox: FC<SearchBoxProps> = ({ version }) => {
  const router = useRouter();

  const currentSearchTerm = router?.query?.q?.toString() || '';

  const [searchTerm, setSearchTerm] = useState<string>(currentSearchTerm);

  const handleSearchTermChanged = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    gtag.event({
      category: 'docs-search',
      action: 'search',
      label: event?.currentTarget?.value ?? 'CLEARED-SEARCH',
    });
    setSearchTerm(event.currentTarget.value);
  };
  // TODO: Correct event types for changed and keyup
  return (
    <>
      <li css={styles.container}>
        <TextInput
          id="left-nav-search-box"
          placeholder="Search Documentation"
          value={searchTerm}
          onKeyUp={(event: any) => {
            if (event.keyCode === 13 && event?.currentTarget?.value) {
              router.push(
                `/docs/${version}/search?q=${event?.currentTarget?.value}`,
              );
            }
          }}
          onChange={handleSearchTermChanged}
        />
      </li>
    </>
  );
};

export default SearchBox;
